
export const styles = ({ palette, _components }) => ({
  inputField: {

  },
  adornment: {
    marginRight: 3,
  },
  reduceLeftMargin: {
    marginRight: 3,
    paddingBottom: 2,
    marginLeft: 3,
  },
  noWrap: {
    whiteSpace: 'nowrap',
  },
  positive: {
    color: palette.number.positive,
  },
  negative: {
    color: palette.number.negative,
  },
});

